import { SECONDARY_GRADES_6_12 } from './secondary-grade-band';

/** Grades shown in the credit table (secondary 6–12). */
export const CREDIT_GRADES = SECONDARY_GRADES_6_12;
